import {_hasProperty} from '../common/helpers/HelperFunc'

export default class ContextSASSLoginProviderVO {
	loginDisabled = false;
	forgotPasswordDisabled = false;
	isChecked = false;
	isExisting = false;
	isFPMailSent = false;
	email = '';
	name = '';
	phoneCode = 'BG'
	phone = '';
	password = '';
	passwordRepeat = '';
	phoneCodes = [];
	orderType = '';

	constructor(params) {
		for (const property in this) {
			if (_hasProperty(this, property) && _hasProperty(params, property)) {
				this[property] = params[property]
			}
		}
	}
}